import {ElementRef, Injectable} from '@angular/core';

@Injectable()
export class MainHeaderService {

  private _contentHostElement: ElementRef;
  public contentElement: ElementRef;

  constructor() {}

  public setContentHost(contentHostElement: ElementRef): void {
    this.unbindElementFromHost();
    this._contentHostElement = contentHostElement;
    this.bindElementToHost();
  }

  public unsetContentHost(): void {
    this.unbindElementFromHost();
    this._contentHostElement = null;
  }

  public setContentElement(contentElement: ElementRef): void {
    this.unbindElementFromHost();
    setTimeout(() => {
      this.contentElement = contentElement;
      this.bindElementToHost();
    });
  }

  public unsetContentElement(): void {
    this.unbindElementFromHost();
    this.contentElement = null;
  }

  private bindElementToHost(): void {
    if (!this._contentHostElement || !this.contentElement) {
      return;
    }
    this._contentHostElement.nativeElement.innerHTML = '';
    this._contentHostElement.nativeElement.appendChild(this.contentElement.nativeElement);
  }

  private unbindElementFromHost(): void {
    if (!this._contentHostElement || !this.contentElement) {
      return;
    }

    if (this.contentElement.nativeElement.parentElement !== this._contentHostElement.nativeElement) {
      return;
    }

    this.contentElement.nativeElement.remove();
  }

}
